module.exports = __webpack_public_path__ + "static/media/default_shop_select.303a57fe.svg";